<script>
  import ProcessPage from '$lib/pages/ProcessPage.svelte';
</script>

<ProcessPage />

